import { JwtHelperService } from "@auth0/angular-jwt";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private jwtHelper: JwtHelperService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (this.jwtHelper.isTokenExpired(sessionStorage.getItem("token"))) {
          console.info("Token is expired");
          sessionStorage.clear();
          window.location.href = "/login"; // Redirect to home
          resolve(false);
        } else {
          console.info("Token is valid");
          resolve(true);
        }
      }, state.url === "/dashboard" ? 0 : 0);
    });
  }
}

export class MockAuthGuard implements CanActivate {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(
  ): Promise<boolean> {
    console.info("MockAuthGuard called");
    return Promise.resolve(true);
  }
}
